import { TableTranslations } from '@/assets/locales/components/table/table.translations.en';

export const tableTranslations: TableTranslations = {
  content: {
    activeFilters: 'Aktywne filtry: {{count}}',
    button: {
      hideFilters: 'Ukryj filtry',
      resetForm: 'Resetuj',
      showFilters: 'Filtry',
      submitSearch: 'Szukaj',
    },
    maxRows: 'Maksymalna liczba wierszy',
    nextPage: 'Następna strona',
    noResults: 'Brak wyników',
    of: 'z',
    previousPage: 'Poprzednia strona',
    quickFilters: 'Szybkie filtry',
  },
};
